"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineNotifyType = exports.OrderGroupState = exports.OrderGroupSubType = exports.GridTrailingIndicatorType = exports.GridTrailingInterval = exports.GridAdjustPositionType = exports.OrderParamsFavType = exports.MartingaleParamPriceType = exports.ManualOrderStatus = exports.SRRecordStatus = exports.SRRecordType = exports.CoinTransferStatus = exports.SymbolStatus = exports.KlineInterval = exports.VerifyCodeType = exports.TransferType = exports.WITHDRAW_REJECT_REASON = exports.DWRecordStatus = exports.WithdrawRecordStatus = exports.DepositRecordStatus = exports.CreateOrderFailedReason = exports.FSTMode = exports.MartingalePriceScaleType = exports.MartingaleSubType = exports.SmartRebalanceSubType = exports.SmartTradeType = exports.GridStopType = exports.GridFuturesTPSLCloseOrderType = exports.GridFuturesInvestmentFrom = exports.GridFuturesMarginStatus = exports.GridFuturesTrend = exports.GridFuturesRiskStatus = exports.GRID_TREND = exports.GRID_TYPE = exports.SRMomentumSubtype = exports.SmartRebalanceMode = exports.MTGStopLossType = exports.MTGCoinScaleType = exports.EnhancedAipStakingStatus = exports.FsaTaskStatus = exports.FsaTaskType = exports.OrderInnerStatus = exports.ExchangeOrderStatus = exports.OrderExternalStatus = exports.ExchangeOrderType = exports.ExchangeOrderSide = exports.OrderTypeDesc = exports.BALANCE_TYPE = exports.FundJournalStatus = exports.FundInvestmentRecordType = void 0;
exports.BotOrderCloseModel = exports.OnlineNotifyActionType = exports.OnlineNotifyBehaviorType = exports.OnlineNotifyExtraType = void 0;
var FundInvestmentRecordType;
(function (FundInvestmentRecordType) {
    FundInvestmentRecordType[FundInvestmentRecordType["TRANSFER"] = 0] = "TRANSFER";
    FundInvestmentRecordType[FundInvestmentRecordType["ORDER"] = 1] = "ORDER";
})(FundInvestmentRecordType = exports.FundInvestmentRecordType || (exports.FundInvestmentRecordType = {}));
var FundJournalStatus;
(function (FundJournalStatus) {
    FundJournalStatus["ERROR"] = "RPC_ERROR";
    FundJournalStatus["FINISHED"] = "FINISHED";
    FundJournalStatus["FAILED"] = "FAILED";
    FundJournalStatus["STUCK"] = "STUCK_PROCESSED";
})(FundJournalStatus = exports.FundJournalStatus || (exports.FundJournalStatus = {}));
var BALANCE_TYPE;
(function (BALANCE_TYPE) {
    BALANCE_TYPE["TRADE"] = "trade";
    BALANCE_TYPE["FUND"] = "fund";
    BALANCE_TYPE["DEBT"] = "debt";
    BALANCE_TYPE["SWAP"] = "swap";
    BALANCE_TYPE["FUTURE"] = "future";
})(BALANCE_TYPE = exports.BALANCE_TYPE || (exports.BALANCE_TYPE = {}));
/**
 * @deprecated use ExchangeOrderType instead
 */
exports.OrderTypeDesc = {
    LIMIT: "limit",
    MARKET: "market",
    STOP_LIMIT: "stop-limit",
    GRID: "grid",
    GRID_CLASSIC: "grid_classic",
    GRID_PRO: "grid_pro",
    GRID_V3: "grid_v3",
    IG: "ig",
    TRAILING_STOP_LIMIT: "trailing_stop",
    AIP: "aip",
    TWAP: "twap",
    GRID_LOAN: "loan_grid",
    GRID_SHORT: "short_grid",
    GRID_LEVERAGE: "leverage_grid",
    GRID_FUTURE: "future_grid",
    GRID_LEVERAGE_SHORT: "short_leverage_grid",
    SL_PRO: "stop_limit_pro",
    SMART_TRADE: "smart_trade",
    FSA: "fsa",
    SR: "smart_rebalance",
    MARTINGALE: "martingale",
    GRID_V4: "grid_v4", // 网格v4
};
var ExchangeOrderSide;
(function (ExchangeOrderSide) {
    ExchangeOrderSide["buy"] = "buy";
    ExchangeOrderSide["sell"] = "sell";
})(ExchangeOrderSide = exports.ExchangeOrderSide || (exports.ExchangeOrderSide = {}));
var ExchangeOrderType;
(function (ExchangeOrderType) {
    ExchangeOrderType["limit"] = "limit";
    ExchangeOrderType["market"] = "market";
    ExchangeOrderType["stopLimit"] = "stop-limit";
    ExchangeOrderType["grid"] = "grid";
    ExchangeOrderType["ig"] = "ig";
    ExchangeOrderType["trailingStop"] = "trailing_stop";
    ExchangeOrderType["aip"] = "aip";
    ExchangeOrderType["twap"] = "twap";
    ExchangeOrderType["gridV3"] = "grid_v3";
    ExchangeOrderType["gridPro"] = "grid_pro";
    ExchangeOrderType["gridClassic"] = "grid_classic";
    ExchangeOrderType["gridLoan"] = "loan_grid";
    ExchangeOrderType["gridShort"] = "short_grid";
    ExchangeOrderType["gridLeverage"] = "leverage_grid";
    ExchangeOrderType["gridFuture"] = "future_grid";
    ExchangeOrderType["gridV4Futures"] = "future_grid_v4";
    ExchangeOrderType["gridV4FuturesHedgeGrid"] = "future_hedge_grid";
    ExchangeOrderType["gridLeverageShort"] = "short_leverage_grid";
    ExchangeOrderType["SL_Pro"] = "stop_limit_pro";
    ExchangeOrderType["smartTrade"] = "smart_trade";
    ExchangeOrderType["trailingBuy"] = "trailing_buy";
    ExchangeOrderType["trailingSell"] = "trailing_sell";
    ExchangeOrderType["fsa"] = "fsa";
    ExchangeOrderType["cm_fsa"] = "cm_fsa";
    ExchangeOrderType["SR"] = "smart_rebalance";
    ExchangeOrderType["martingale"] = "martingale";
    ExchangeOrderType["SC"] = "smart_copy";
    ExchangeOrderType["reverse_fsa"] = "reverse_fsa";
    ExchangeOrderType["enhanced_aip"] = "enhanced_aip";
    ExchangeOrderType["post"] = "post";
    ExchangeOrderType["market_qty"] = "market_qty";
    ExchangeOrderType["market_amt"] = "market_amt";
    ExchangeOrderType["ats"] = "ats";
    ExchangeOrderType["gridV4"] = "grid_v4";
    ExchangeOrderType["gridV5"] = "grid_v5";
    ExchangeOrderType["bitfinex_certificate"] = "bitfinex_certificate";
    /**
     *  理财 自动复投
     */
    ExchangeOrderType["dual_auto"] = "dual_auto";
    ExchangeOrderType["order_group"] = "order_group";
    ExchangeOrderType["futures_smart_trade"] = "futures_smart_trade";
})(ExchangeOrderType = exports.ExchangeOrderType || (exports.ExchangeOrderType = {}));
var OrderExternalStatus;
(function (OrderExternalStatus) {
    OrderExternalStatus["open"] = "open";
    OrderExternalStatus["prepare"] = "prepare";
    OrderExternalStatus["pending"] = "pending";
    OrderExternalStatus["closed"] = "closed";
    OrderExternalStatus["partialFilled"] = "partial_filled";
    OrderExternalStatus["canceled"] = "canceled";
    OrderExternalStatus["canceling"] = "canceling";
    OrderExternalStatus["preCancel"] = "pre-cancel";
})(OrderExternalStatus = exports.OrderExternalStatus || (exports.OrderExternalStatus = {}));
var ExchangeOrderStatus;
(function (ExchangeOrderStatus) {
    ExchangeOrderStatus["submitted"] = "submitted";
    ExchangeOrderStatus["filled"] = "filled";
    ExchangeOrderStatus["partialFilled"] = "partial_filled";
    ExchangeOrderStatus["canceled"] = "canceled";
    ExchangeOrderStatus["canceling"] = "canceling";
    ExchangeOrderStatus["closed"] = "closed";
})(ExchangeOrderStatus = exports.ExchangeOrderStatus || (exports.ExchangeOrderStatus = {}));
/**
 *
 * gridPro 订单内外部状态
 *
 *     'prepare': 'prepare',
 *     'lock_currency': 'open',
 *     'condition_lock': 'open',
 *     'assets_allocation': 'open',
 *     'fee_allocation': 'open',
 *     'open_position': 'open',
 *     'init_grid': 'open',
 *     'running': 'open',
 *     'pausing': 'open',
 *     'liquidating': 'open',
 *     'destroy_grid': 'canceling',
 *     'assets_deallocation': 'canceling',
 *     'close_position': 'canceling',
 *     'unlock_currency': 'canceling',
 *     'canceled': 'canceled',
 *     //以下为加仓过程产生的进度
 *     'adjust_investment_in': 'open',
 'adjust_fee_allocation': 'open',
 'adjust_open_position': 'open',
 'adjust_init_grid': 'open',
 *
 * futureGrid 订单内外部状态
 *     'prepare': 'prepare',
 *     'condition_lock': 'open',
 *     'validate': 'open',
 *     'open_position': 'open',
 *     'check_position': 'open',
 *     'init_grid': 'open',
 *     'running': 'open',
 *     'destroy_grid': 'canceling',
 *     'close_position': 'canceling',
 *     'clean_up': 'canceling',
 *     'canceled': 'canceled',
 *
 *
 *stop_limit_pro 订单内部状态
 *     'prepare': 'prepare',
 *     'validate': 'open',
 *     'lock_currency': 'open',
 *     'condition_lock': 'open',
 *     'create_order': 'open',
 *     'checking': 'open',
 *     'closed': 'closed',
 *     'destroy_order': 'canceling',
 *     'unlock_currency': 'canceling',
 *     'canceled': 'canceled',
 *
 *
 *
 *"smart_trade" 订单内部状态
 *     state_check_balance: 查看余额
 *     state_allocate_strategy: 创建策略ID(锁定资金准备)
 *     state_lock_amount_strategy: 锁定资金
 *     state_market_buy: 下买单
 *     state_market_buying: 等待买单成交
 *     state_check_trigger_price: 等待卖单触发价
 *     state_stop_price_test: 已经到达触发价，判断回撤比
 *     state_market_sell: 下卖单
 *     state_market_selling: 等待卖单成交
 *     state_clear_strategy: 释放资金
 *     state_canceling:取消中
 *     'canceled': 'canceled',
 *     StopLossCompleted = "state_stop_loss_completed"
 *     StopProfitCompleted = "state_stop_profit_completed"
 *
 *
 *
 *
 *    "fsa" 订单内部状态
 *    'prepare': 'prepare',
 *    'initialize': 'open',
 *    'lock_currency': 'open',
 *    'open_position': 'open',
 *    'running': 'open',
 *    'adjust_position': 'open',
 *    'adjust_assets':'open',
 *    'change_margin':'open',
 *    'unlock_currency': 'canceling',
 *    'close_position': 'canceling',
 *    'retrieve_data': 'canceling',
 *    'canceled': 'canceled',
 *    'deduct':表示在扣费，减仓、自动降杠杆、关单时，都会出现,
 *    'pre-cancel':'canceling'
 *
 * 'sr'订单内部状态

 'prepare': 'prepare',
 'lock_currency': 'open',
 'condition_lock': 'open',
 'assets_allocation': 'open',
 'open_position': 'open',
 'init_strategy': 'open',
 'running': 'open',
 'adjust_investment': 'open',
 'destroy_strategy': 'canceling',
 'assets_deallocation': 'canceling',
 'close_position': 'canceling',
 'unlock_currency': 'canceling',
 'canceled': 'canceled',
 'updatePortfolio':'updatePortfolio',
 *
 *
 * ig 内部状态
 *    # 平衡单 -> 锁仓 -> 初始挂单
 PREPARE = 'prepare'
 # 触发价
 CONDITION_LOCK = 'condition_lock'
 # 开单
 OPEN_POSITION = 'open_position'
 # 主策略循环
 CHECKING = 'checking'
 # 撤单
 CANCELING = 'canceling'
 # 清算: 卖 base
 LIQUIDATION = 'liquidation'
 # 解仓
 RELEASE = 'release'
 # 等待恢复
 PENDING = 'pending'
 # 卡住: 撤单状态出现不可恢复错误
 STUCK = 'stuck'
 # 已取消
 CANCELED = 'canceled'
 # 错误
 ERROR = 'error'
 # 已关闭
 CLOSED = 'closed'
 */
/** enhanced_aip 内部状态
 * initialize

 create_strategy

 condition_lock

 init_price

 init_running

 running

 canceling

 close_position

 clear_strategy

 pause

 canceled
 */
var OrderInnerStatus;
(function (OrderInnerStatus) {
    OrderInnerStatus["prepare"] = "prepare";
    OrderInnerStatus["lockCurrency"] = "lock_currency";
    OrderInnerStatus["conditionLock"] = "condition_lock";
    OrderInnerStatus["assetsAllocation"] = "assets_allocation";
    OrderInnerStatus["feeAllocation"] = "fee_allocation";
    OrderInnerStatus["openPosition"] = "open_position";
    OrderInnerStatus["initGrid"] = "init_grid";
    OrderInnerStatus["running"] = "running";
    OrderInnerStatus["liquidating"] = "liquidating";
    OrderInnerStatus["destroyGrid"] = "destroy_grid";
    OrderInnerStatus["assetsDeallocation"] = "assets_deallocation";
    OrderInnerStatus["closePosition"] = "close_position";
    OrderInnerStatus["unlockCurrency"] = "unlock_currency";
    OrderInnerStatus["canceled"] = "canceled";
    OrderInnerStatus["validateGrid"] = "validate_grid";
    OrderInnerStatus["checkPosition"] = "check_position";
    OrderInnerStatus["cleanUp"] = "clean_up";
    OrderInnerStatus["validate"] = "validate";
    OrderInnerStatus["createOrder"] = "create_order";
    OrderInnerStatus["checking"] = "checking";
    OrderInnerStatus["closed"] = "closed";
    OrderInnerStatus["destroyOrder"] = "destroy_order";
    OrderInnerStatus["stateCheckBalance"] = "state_check_balance";
    OrderInnerStatus["stateAllocateStrategy"] = "state_allocate_strategy";
    OrderInnerStatus["stateLockAmountStrategy"] = "state_lock_amount_strategy";
    OrderInnerStatus["stateMarketBuy"] = "state_market_buy";
    OrderInnerStatus["stateMarketBuying"] = "state_market_buying";
    OrderInnerStatus["stateCheckTriggerPrice"] = "state_check_trigger_price";
    OrderInnerStatus["stateStopPriceTest"] = "state_stop_price_test";
    OrderInnerStatus["stateMarketSell"] = "state_market_sell";
    OrderInnerStatus["stateMarketSelling"] = "state_market_selling";
    OrderInnerStatus["stateClearStrategy"] = "state_clear_strategy";
    OrderInnerStatus["stateCanceling"] = "state_canceling";
    OrderInnerStatus["initialize"] = "initialize";
    OrderInnerStatus["adjustPosition"] = "adjust_position";
    OrderInnerStatus["adjustAssets"] = "adjust_assets";
    OrderInnerStatus["changeMargin"] = "change_margin";
    OrderInnerStatus["retrieveData"] = "retrieve_data";
    OrderInnerStatus["deduct"] = "deduct";
    OrderInnerStatus["init"] = "init";
    OrderInnerStatus["preCanceling"] = "pre-cancel";
    OrderInnerStatus["adjustInvestment"] = "adjust_investment";
    OrderInnerStatus["destroyStrategy"] = "destroy_strategy";
    OrderInnerStatus["addPosition"] = "add_position";
    OrderInnerStatus["reducePosition"] = "reduce_position";
    OrderInnerStatus["investing"] = "investing";
    OrderInnerStatus["adjustInvestmentIn"] = "adjust_investment_in";
    OrderInnerStatus["replenishInvestmentIn"] = "replenish_investment_in";
    OrderInnerStatus["adjustInvestmentOut"] = "adjust_investment_out";
    OrderInnerStatus["renewRound"] = "renew_round";
    OrderInnerStatus["pausing"] = "pausing";
    OrderInnerStatus["paused"] = "paused";
    OrderInnerStatus["resuming"] = "resuming";
    OrderInnerStatus["adjustFeeAllocation"] = "adjust_fee_allocation";
    OrderInnerStatus["adjustOpenPosition"] = "adjust_open_position";
    OrderInnerStatus["adjustInitGrid"] = "adjust_init_grid";
    OrderInnerStatus["adjustParams"] = "adjust_params";
    OrderInnerStatus["adjustParamsFeeAllocation"] = "adjust_params_fee_allocation";
    OrderInnerStatus["adjustParamsOpenPosition"] = "adjust_params_open_position";
    OrderInnerStatus["adjustParamsInitGrid"] = "adjust_params_init_grid";
    OrderInnerStatus["prePause"] = "pre-pause";
    OrderInnerStatus["preResume"] = "pre-resume";
    OrderInnerStatus["preAdjustParams"] = "pre-adjust-params";
    OrderInnerStatus["updatePortfolio"] = "update_portfolio";
    OrderInnerStatus["createStrategy"] = "create_strategy";
    OrderInnerStatus["initPrice"] = "init_price";
    OrderInnerStatus["initRunning"] = "init_running";
    OrderInnerStatus["canceling"] = "canceling";
    OrderInnerStatus["clearStrategy"] = "clear_strategy";
    OrderInnerStatus["pause"] = "pause";
    OrderInnerStatus["allocateAssets"] = "allocate_assets";
    OrderInnerStatus["initMainLoop"] = "init_main_loop";
    OrderInnerStatus["shareProfit"] = "share_profit";
    OrderInnerStatus["allocateFund"] = "allocate_fund";
    OrderInnerStatus["transferIn"] = "transfer_in";
    OrderInnerStatus["transferOut"] = "transfer_out";
    OrderInnerStatus["mainLoop"] = "main_loop";
})(OrderInnerStatus = exports.OrderInnerStatus || (exports.OrderInnerStatus = {}));
var FsaTaskType;
(function (FsaTaskType) {
    FsaTaskType["addPosition"] = "add_position";
    FsaTaskType["reducePosition"] = "reduce_position";
    FsaTaskType["cancel"] = "cancel";
    FsaTaskType["reduceLeverage"] = "reduce_leverage";
})(FsaTaskType = exports.FsaTaskType || (exports.FsaTaskType = {}));
var FsaTaskStatus;
(function (FsaTaskStatus) {
    FsaTaskStatus["adjustPosition"] = "adjust_position";
    FsaTaskStatus["unlockSpot"] = "unlock_spot";
    FsaTaskStatus["transferToSwap"] = "transfer_to_swap";
    FsaTaskStatus["adjustPosition2"] = "adjust_position_2";
    FsaTaskStatus["chargeToMargin"] = "charge_to_margin";
})(FsaTaskStatus = exports.FsaTaskStatus || (exports.FsaTaskStatus = {}));
var EnhancedAipStakingStatus;
(function (EnhancedAipStakingStatus) {
    EnhancedAipStakingStatus["check"] = "check";
    EnhancedAipStakingStatus["not_enough_balance"] = "not_enough_balance";
    EnhancedAipStakingStatus["prepare_allocate_asset"] = "prepare_allocate_asset";
    EnhancedAipStakingStatus["allocate_asset"] = "allocate_asset";
    EnhancedAipStakingStatus["prepare_buy"] = "prepare_buy";
    EnhancedAipStakingStatus["buy"] = "buy";
    EnhancedAipStakingStatus["finish_buy"] = "finish_buy";
    EnhancedAipStakingStatus["prepare_staking"] = "prepare_staking";
    EnhancedAipStakingStatus["staking"] = "staking";
    EnhancedAipStakingStatus["finish_staking"] = "finish_staking";
})(EnhancedAipStakingStatus = exports.EnhancedAipStakingStatus || (exports.EnhancedAipStakingStatus = {}));
var MTGCoinScaleType;
(function (MTGCoinScaleType) {
    MTGCoinScaleType["percentage"] = "percentage";
    MTGCoinScaleType["fixedNum"] = "fixed_num";
    MTGCoinScaleType["custom"] = "custom";
})(MTGCoinScaleType = exports.MTGCoinScaleType || (exports.MTGCoinScaleType = {}));
var MTGStopLossType;
(function (MTGStopLossType) {
    MTGStopLossType["baseUnrealizedProfit"] = "baseUnrealizedProfit";
    MTGStopLossType["baseTotalProfit"] = "baseTotalProfit";
})(MTGStopLossType = exports.MTGStopLossType || (exports.MTGStopLossType = {}));
var SmartRebalanceMode;
(function (SmartRebalanceMode) {
    SmartRebalanceMode["periodic"] = "periodic";
    SmartRebalanceMode["threshold"] = "threshold";
    SmartRebalanceMode["momentum"] = "momentum";
})(SmartRebalanceMode = exports.SmartRebalanceMode || (exports.SmartRebalanceMode = {}));
var SRMomentumSubtype;
(function (SRMomentumSubtype) {
    SRMomentumSubtype["momentum_periodic"] = "momentum_periodic";
    SRMomentumSubtype["momentum_threshold"] = "momentum_threshold";
})(SRMomentumSubtype = exports.SRMomentumSubtype || (exports.SRMomentumSubtype = {}));
/**
 * 等差 or 等比 网格
 */
var GRID_TYPE;
(function (GRID_TYPE) {
    GRID_TYPE["arithmetic"] = "arithmetic";
    GRID_TYPE["geometric"] = "geometric";
})(GRID_TYPE = exports.GRID_TYPE || (exports.GRID_TYPE = {}));
/**
 * 看多 or 看空
 */
var GRID_TREND;
(function (GRID_TREND) {
    GRID_TREND["long"] = "long";
    GRID_TREND["short"] = "short";
})(GRID_TREND = exports.GRID_TREND || (exports.GRID_TREND = {}));
var GridFuturesRiskStatus;
(function (GridFuturesRiskStatus) {
    GridFuturesRiskStatus["TRADING"] = "TRADING";
    GridFuturesRiskStatus["HOLDING"] = "HOLDING";
    GridFuturesRiskStatus["TAKEOVER"] = "TAKEOVER";
    GridFuturesRiskStatus["LIQUIDATION"] = "LIQUIDATION";
})(GridFuturesRiskStatus = exports.GridFuturesRiskStatus || (exports.GridFuturesRiskStatus = {}));
var GridFuturesTrend;
(function (GridFuturesTrend) {
    GridFuturesTrend["long"] = "long";
    GridFuturesTrend["short"] = "short";
    GridFuturesTrend["no_trend"] = "no_trend";
})(GridFuturesTrend = exports.GridFuturesTrend || (exports.GridFuturesTrend = {}));
var GridFuturesMarginStatus;
(function (GridFuturesMarginStatus) {
    GridFuturesMarginStatus["NORMAL"] = "NORMAL";
    GridFuturesMarginStatus["INSUFFICIENT"] = "INSUFFICIENT";
})(GridFuturesMarginStatus = exports.GridFuturesMarginStatus || (exports.GridFuturesMarginStatus = {}));
/**
 * 合约网格的资金来源的枚举。
 * USER： 指来自用户的主账号
 * LOCK_ACTIVITY：指来自锁仓单活动运营池
 * FUTURE_GRID_BONUS: 发财金
 */
var GridFuturesInvestmentFrom;
(function (GridFuturesInvestmentFrom) {
    GridFuturesInvestmentFrom["USER"] = "USER";
    GridFuturesInvestmentFrom["LOCK_ACTIVITY"] = "LOCK_ACTIVITY";
    GridFuturesInvestmentFrom["FUTURE_GRID_BONUS"] = "FUTURE_GRID_BONUS";
})(GridFuturesInvestmentFrom = exports.GridFuturesInvestmentFrom || (exports.GridFuturesInvestmentFrom = {}));
// 止盈止损平仓类型
var GridFuturesTPSLCloseOrderType;
(function (GridFuturesTPSLCloseOrderType) {
    GridFuturesTPSLCloseOrderType["market"] = "MARKET";
    GridFuturesTPSLCloseOrderType["limit"] = "LIMIT";
    GridFuturesTPSLCloseOrderType["limitHigh"] = "LIMIT_HIGH";
})(GridFuturesTPSLCloseOrderType = exports.GridFuturesTPSLCloseOrderType || (exports.GridFuturesTPSLCloseOrderType = {}));
/** 止盈止损的触发类型 */
var GridStopType;
(function (GridStopType) {
    /** 按价格止盈止损 默认值 */
    GridStopType["price"] = "price";
    /** 按限价价格止盈止损 */
    GridStopType["price_limit"] = "price_limit";
    /** 按盈利额/亏损额 */
    GridStopType["profit_amount"] = "profit_amount";
    /** 按盈利比率/亏损比率 */
    GridStopType["profit_ratio"] = "profit_ratio";
})(GridStopType = exports.GridStopType || (exports.GridStopType = {}));
var SmartTradeType;
(function (SmartTradeType) {
    SmartTradeType["smart_trade_sell_only"] = "smart_trade_sell_only";
    SmartTradeType["smart_trade_buy_only"] = "smart_trade_buy_only";
    SmartTradeType["smart_trade"] = "smart_trade";
})(SmartTradeType = exports.SmartTradeType || (exports.SmartTradeType = {}));
var SmartRebalanceSubType;
(function (SmartRebalanceSubType) {
    SmartRebalanceSubType["double_coins"] = "double_coins";
    SmartRebalanceSubType["multi_coins"] = "multi_coins";
})(SmartRebalanceSubType = exports.SmartRebalanceSubType || (exports.SmartRebalanceSubType = {}));
var MartingaleSubType;
(function (MartingaleSubType) {
    MartingaleSubType["normal"] = "normal";
    MartingaleSubType["smart_trade"] = "smart_trade";
})(MartingaleSubType = exports.MartingaleSubType || (exports.MartingaleSubType = {}));
/**
 * 挂单模式
 * percentage 等比
 * fixed_num 等差
 */
var MartingalePriceScaleType;
(function (MartingalePriceScaleType) {
    MartingalePriceScaleType["percentage"] = "percentage";
    MartingalePriceScaleType["fixed_num"] = "fixed_num";
    MartingalePriceScaleType["custom"] = "custom";
})(MartingalePriceScaleType = exports.MartingalePriceScaleType || (exports.MartingalePriceScaleType = {}));
var FSTMode;
(function (FSTMode) {
    FSTMode["market"] = "market";
    FSTMode["limit"] = "limit";
    FSTMode["post"] = "post";
    FSTMode["trailing"] = "trailing";
    FSTMode["signal"] = "signal";
})(FSTMode = exports.FSTMode || (exports.FSTMode = {}));
exports.CreateOrderFailedReason = {
    lowAmount: 1,
    lowPrice: 2,
    lowQuoteAmount: 3,
    priceInvalid: 4,
};
var DepositRecordStatus;
(function (DepositRecordStatus) {
    DepositRecordStatus["NOTIFIED"] = "NOTIFIED";
    DepositRecordStatus["RECEIVED"] = "RECEIVED";
    DepositRecordStatus["CONFIRMED"] = "CONFIRMED";
    DepositRecordStatus["ABNORMAL"] = "ABNORMAL";
    DepositRecordStatus["RISKY"] = "RISKY";
    DepositRecordStatus["CHECKING"] = "CHECKING";
    DepositRecordStatus["RETURNED"] = "RETURNED";
})(DepositRecordStatus = exports.DepositRecordStatus || (exports.DepositRecordStatus = {}));
var WithdrawRecordStatus;
(function (WithdrawRecordStatus) {
    WithdrawRecordStatus["APPLIED"] = "APPLIED";
    WithdrawRecordStatus["APPROVED"] = "APPROVED";
    WithdrawRecordStatus["SHORTAGE"] = "SHORTAGE";
    WithdrawRecordStatus["REJECTED"] = "REJECTED";
    WithdrawRecordStatus["HICOIN_REJECTED"] = "HICOIN_REJECTED";
    WithdrawRecordStatus["REMITTED"] = "REMITTED";
    WithdrawRecordStatus["FINISHED"] = "FINISHED";
    WithdrawRecordStatus["CANCELED"] = "CANCELED";
    WithdrawRecordStatus["FAILED"] = "FAILED";
})(WithdrawRecordStatus = exports.WithdrawRecordStatus || (exports.WithdrawRecordStatus = {}));
var DWRecordStatus;
(function (DWRecordStatus) {
    DWRecordStatus["reviewing"] = "reviewing";
    DWRecordStatus["withdrawing"] = "withdrawing";
    DWRecordStatus["processing"] = "processing";
    DWRecordStatus["complete"] = "complete";
    DWRecordStatus["confirmed"] = "confirmed";
    DWRecordStatus["failed"] = "failed";
    DWRecordStatus["remitted"] = "remitted";
    DWRecordStatus["canceled"] = "canceled";
    DWRecordStatus["risk"] = "risk";
    DWRecordStatus["returned"] = "returned";
})(DWRecordStatus = exports.DWRecordStatus || (exports.DWRecordStatus = {}));
var WITHDRAW_REJECT_REASON;
(function (WITHDRAW_REJECT_REASON) {
    WITHDRAW_REJECT_REASON["riskyAccount"] = "RISKY_ACCOUNT";
    WITHDRAW_REJECT_REASON["systemBusy"] = "SYSTEM_BUSY";
    WITHDRAW_REJECT_REASON["invalidAddress"] = "INVALID_ADDRESS";
    WITHDRAW_REJECT_REASON["walletRejected"] = "HICOIN_REJECTED";
})(WITHDRAW_REJECT_REASON = exports.WITHDRAW_REJECT_REASON || (exports.WITHDRAW_REJECT_REASON = {}));
var TransferType;
(function (TransferType) {
    TransferType["profit"] = "profit";
    TransferType["margin"] = "margin";
    TransferType["investment"] = "investment";
    TransferType["replenish"] = "replenish";
})(TransferType = exports.TransferType || (exports.TransferType = {}));
var VerifyCodeType;
(function (VerifyCodeType) {
    VerifyCodeType[VerifyCodeType["sms"] = 0] = "sms";
    VerifyCodeType[VerifyCodeType["call"] = 1] = "call";
})(VerifyCodeType = exports.VerifyCodeType || (exports.VerifyCodeType = {}));
var KlineInterval;
(function (KlineInterval) {
    KlineInterval["min1"] = "1m";
    KlineInterval["min5"] = "5m";
    KlineInterval["min15"] = "15m";
    KlineInterval["min30"] = "30m";
    KlineInterval["hour1"] = "1h";
    KlineInterval["hour4"] = "4h";
    KlineInterval["hour8"] = "8h";
    KlineInterval["hour12"] = "12h";
    KlineInterval["day1"] = "1d";
    KlineInterval["day7"] = "7d";
    KlineInterval["month1"] = "30d";
})(KlineInterval = exports.KlineInterval || (exports.KlineInterval = {}));
var SymbolStatus;
(function (SymbolStatus) {
    SymbolStatus[SymbolStatus["normal"] = 0] = "normal";
    SymbolStatus[SymbolStatus["MaintainedWithoutForbidden"] = 1] = "MaintainedWithoutForbidden";
    SymbolStatus[SymbolStatus["MaintainedAndForbidden"] = 2] = "MaintainedAndForbidden";
})(SymbolStatus = exports.SymbolStatus || (exports.SymbolStatus = {}));
var CoinTransferStatus;
(function (CoinTransferStatus) {
    CoinTransferStatus["enabled"] = "ENABLED";
    CoinTransferStatus["disabled"] = "DISABLED";
    CoinTransferStatus["maintenance"] = "MAINTENANCE";
})(CoinTransferStatus = exports.CoinTransferStatus || (exports.CoinTransferStatus = {}));
var SRRecordType;
(function (SRRecordType) {
    SRRecordType["rebalance"] = "rebalance";
    SRRecordType["adjustInvestmentIn"] = "adjust_investment_in";
    SRRecordType["adjustInvestmentOut"] = "adjust_investment_out";
    SRRecordType["updatePortfolio"] = "update_portfolio";
    SRRecordType["allocateOut"] = "allocate_out";
    SRRecordType["allocateOutAdmin"] = "allocate_out_admin";
})(SRRecordType = exports.SRRecordType || (exports.SRRecordType = {}));
var SRRecordStatus;
(function (SRRecordStatus) {
    SRRecordStatus["done"] = "done";
    SRRecordStatus["skipped"] = "skipped";
})(SRRecordStatus = exports.SRRecordStatus || (exports.SRRecordStatus = {}));
/**
 * pionex 手动单状态（前端定义），实际状态SUBMITTED,CONFIRMED,PARTIAL_FILLED,FILLED,CANCELED
 running包含SUBMITTED,CONFIRMED,PARTIAL_FILLED
 funished包含：FILLED,CANCELED

 */
var ManualOrderStatus;
(function (ManualOrderStatus) {
    ManualOrderStatus[ManualOrderStatus["running"] = 0] = "running";
    ManualOrderStatus[ManualOrderStatus["finished"] = 1] = "finished";
    ManualOrderStatus[ManualOrderStatus["filled"] = 2] = "filled";
    ManualOrderStatus[ManualOrderStatus["canceled"] = 3] = "canceled";
})(ManualOrderStatus = exports.ManualOrderStatus || (exports.ManualOrderStatus = {}));
var MartingaleParamPriceType;
(function (MartingaleParamPriceType) {
    MartingaleParamPriceType["takeProfitPercentage"] = "takeProfitPercentage";
    MartingaleParamPriceType["stopLossPercentage"] = "stopLossPercentage";
    MartingaleParamPriceType["stopLossBaseUnrealizedProfit"] = "stopLossBaseUnrealizedProfit";
    MartingaleParamPriceType["stopScalePrice"] = "stopScalePrice";
})(MartingaleParamPriceType = exports.MartingaleParamPriceType || (exports.MartingaleParamPriceType = {}));
var OrderParamsFavType;
(function (OrderParamsFavType) {
    OrderParamsFavType["martingale"] = "martingale";
    OrderParamsFavType["smart_martingale"] = "smart_martingale";
})(OrderParamsFavType = exports.OrderParamsFavType || (exports.OrderParamsFavType = {}));
var GridAdjustPositionType;
(function (GridAdjustPositionType) {
    GridAdjustPositionType["open"] = "open";
    GridAdjustPositionType["close"] = "close";
    GridAdjustPositionType["addPosition"] = "invest_in";
    GridAdjustPositionType["adjustParams"] = "adjust_params";
    /**
     * 套利利润复投
     */
    GridAdjustPositionType["profitAutoReinvest"] = "profit_auto_reinvest";
})(GridAdjustPositionType = exports.GridAdjustPositionType || (exports.GridAdjustPositionType = {}));
//移动网格适用，后续有新增
var GridTrailingInterval;
(function (GridTrailingInterval) {
    GridTrailingInterval["minute_1"] = "1m";
    GridTrailingInterval["minute_15"] = "15m";
    GridTrailingInterval["minute_30"] = "15m";
    GridTrailingInterval["hour_1"] = "1h";
    GridTrailingInterval["hour_4"] = "4h";
    GridTrailingInterval["hour_12"] = "12h";
})(GridTrailingInterval = exports.GridTrailingInterval || (exports.GridTrailingInterval = {}));
var GridTrailingIndicatorType;
(function (GridTrailingIndicatorType) {
    GridTrailingIndicatorType["sma"] = "sma";
})(GridTrailingIndicatorType = exports.GridTrailingIndicatorType || (exports.GridTrailingIndicatorType = {}));
var OrderGroupSubType;
(function (OrderGroupSubType) {
    OrderGroupSubType["same"] = "same";
    OrderGroupSubType["mixed"] = "mixed";
})(OrderGroupSubType = exports.OrderGroupSubType || (exports.OrderGroupSubType = {}));
var OrderGroupState;
(function (OrderGroupState) {
    OrderGroupState["open"] = "open";
    OrderGroupState["close"] = "close";
})(OrderGroupState = exports.OrderGroupState || (exports.OrderGroupState = {}));
var OnlineNotifyType;
(function (OnlineNotifyType) {
    OnlineNotifyType["ALERT"] = "ALERT";
})(OnlineNotifyType = exports.OnlineNotifyType || (exports.OnlineNotifyType = {}));
var OnlineNotifyExtraType;
(function (OnlineNotifyExtraType) {
    OnlineNotifyExtraType["COMPLETE"] = "COMPLETE";
    OnlineNotifyExtraType["WARNING"] = "WARNING";
    OnlineNotifyExtraType["SOUND_ONLY"] = "SOUND_ONLY";
})(OnlineNotifyExtraType = exports.OnlineNotifyExtraType || (exports.OnlineNotifyExtraType = {}));
var OnlineNotifyBehaviorType;
(function (OnlineNotifyBehaviorType) {
    OnlineNotifyBehaviorType["FUTURE_GRID_OPEN"] = "FUTURE_GRID_OPEN";
    OnlineNotifyBehaviorType["FUTURE_GRID_ARBITRAGE"] = "FUTURE_GRID_ARBITRAGE";
})(OnlineNotifyBehaviorType = exports.OnlineNotifyBehaviorType || (exports.OnlineNotifyBehaviorType = {}));
var OnlineNotifyActionType;
(function (OnlineNotifyActionType) {
    OnlineNotifyActionType["SOUND"] = "SOUND";
})(OnlineNotifyActionType = exports.OnlineNotifyActionType || (exports.OnlineNotifyActionType = {}));
var BotOrderCloseModel;
(function (BotOrderCloseModel) {
    BotOrderCloseModel["NOT_SELL"] = "NOT_SELL";
    BotOrderCloseModel["TO_QUOTE"] = "TO_QUOTE";
    BotOrderCloseModel["TO_USDT"] = "TO_USDT";
})(BotOrderCloseModel = exports.BotOrderCloseModel || (exports.BotOrderCloseModel = {}));
